(function () {
  'use strict';

  var GRACE_PATH = '/collections/grace-wig';
  var SEARCHANISE_KEY = 'rb_filter_option_ba2a9c6c8c77e03f83ef8bf543612275';
  var DEBUG_KEY = 'graceRedirectDebug';
  var STYLES = [
    '12" Halle',
    '13" Victoria',
    '16" Naomi',
    '19" Nicole',
    '22" Reese',
    '24" Gisele',
    '26" Amber'
  ];

  var pathname = window.location.pathname.replace(/\/$/, '');
  if (pathname !== GRACE_PATH) return;

  var params = new URLSearchParams(window.location.search);
  var debugEnabled = params.get(DEBUG_KEY) === '1';

  function debug() {
    if (!debugEnabled || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Grace URL redirect]');
    window.console.info.apply(window.console, args);
  }

  function safelyDecode(value) {
    var decoded = String(value || '').replace(/\+/g, ' ');
    if (decoded.indexOf('%') === -1) return decoded;

    try {
      return decodeURIComponent(decoded);
    } catch (error) {
      return decoded;
    }
  }

  function normalize(value) {
    return safelyDecode(value)
      .replace(/[\u201c\u201d\u201e\u201f\u2033\u02ba]/g, '"')
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .replace(/'{2}/g, '"')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function matchStyle(value) {
    var normalized = normalize(value);
    if (!normalized) return '';

    return (
      STYLES.find(function (style) {
        return normalize(style) === normalized;
      }) || ''
    );
  }

  function findFallbackSearchaniseValue() {
    var fallback = null;
    params.forEach(function (value, key) {
      if (
        fallback === null &&
        key.indexOf('rb_filter_option_') === 0 &&
        key !== SEARCHANISE_KEY &&
        matchStyle(value)
      ) {
        fallback = value;
      }
    });
    return fallback;
  }

  var oldStyleValue = params.get('filter.style');
  var exactSearchaniseValue = params.get(SEARCHANISE_KEY);
  var fallbackSearchaniseValue =
    exactSearchaniseValue === null ? findFallbackSearchaniseValue() : null;
  var detectedSearchaniseValue =
    exactSearchaniseValue !== null ? exactSearchaniseValue : fallbackSearchaniseValue;

  var matchedSearchaniseStyle = matchStyle(detectedSearchaniseValue);
  var matchedOldStyle =
    detectedSearchaniseValue === null ? matchStyle(oldStyleValue) : '';
  var matchedStyle = matchedSearchaniseStyle || matchedOldStyle;

  debug('current URL', window.location.href);
  debug('detected filter.style', oldStyleValue);
  debug('detected rb_filter_option value', detectedSearchaniseValue);
  debug('matched style', matchedStyle || '(none)');

  if (!matchedStyle) {
    debug('redirect skipped: no recognized Grace style');
    return;
  }

  // Multi-select safety: if the canonical key already carries 2+ values
  // (shopper multi-selected the Style facet), leave the URL alone —
  // canonicalizing would collapse it to one style.
  if (params.getAll(SEARCHANISE_KEY).length > 1) {
    debug('redirect skipped: canonical key is multi-valued');
    return;
  }

  // Canonicalize IN PLACE: keep every unrelated param (utm_*, gclid, other
  // Searchanise filters) so campaign attribution and secondary filters
  // survive the redirect. Only the legacy style params are swapped for the
  // canonical key. Deterministic rebuild = loop-safe (second pass produces
  // an identical string and the guard below skips the redirect).
  var targetParams = new URLSearchParams(window.location.search);
  targetParams.delete('filter.style');
  var staleStyleKeys = [];
  targetParams.forEach(function (value, key) {
    if (key.indexOf('rb_filter_option_') === 0 && key !== SEARCHANISE_KEY && matchStyle(value)) {
      staleStyleKeys.push(key);
    }
  });
  staleStyleKeys.forEach(function (key) { targetParams.delete(key); });
  // Reset pagination ONLY when actually migrating a legacy param — the
  // legacy filter differs from what the page showed, so a carried-over
  // page number could point past the end of the filtered set. Already-
  // canonical URLs keep their page (no redirect fires for them at all).
  if (matchedOldStyle || staleStyleKeys.length > 0) {
    targetParams.delete('page');
  }
  targetParams.set(SEARCHANISE_KEY, matchedStyle);
  var targetUrl = GRACE_PATH + '?' + targetParams.toString();
  var currentUrl = pathname + '?' + new URLSearchParams(window.location.search).toString();

  debug('target URL', targetUrl);

  if (currentUrl === targetUrl) {
    debug('redirect skipped: URL is already canonical');
    return;
  }

  debug('redirect performed');
  window.location.replace(targetUrl);
})();
